import { Injectable, signal } from '@angular/core';
import { GeneratedTimelineCardData } from '../_interfaces';

@Injectable({
    providedIn: 'root'
})
export class SeeAllArticlesStateService {
    private current = signal<GeneratedTimelineCardData | null>(null)

    constructor() { }

    setCard(card: GeneratedTimelineCardData) {
        this.current.set(card)
    }

    getCard() {
        return this.current()
    }

    resetCard() {
        this.current.set(null)
    }
}
